/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Error_ProcessingInputs */

const en_register_onboarding_personal_info_error_processing = /** @type {(inputs: Register_Onboarding_Personal_Info_Error_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while processing the resume.`)
};

const de_register_onboarding_personal_info_error_processing = /** @type {(inputs: Register_Onboarding_Personal_Info_Error_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Verarbeiten des Lebenslaufs ist ein Fehler aufgetreten.`)
};

/**
* | output |
* | --- |
* | "An error occurred while processing the resume." |
*
* @param {Register_Onboarding_Personal_Info_Error_ProcessingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_error_processing = /** @type {((inputs?: Register_Onboarding_Personal_Info_Error_ProcessingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Error_ProcessingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_error_processing(inputs)
	return en_register_onboarding_personal_info_error_processing(inputs)
});